import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, App } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import tagService from '../services/tag';

const QuestionTagManage = () => {
  const { message } = App.useApp();
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    console.log('QuestionTagManage 组件加载');
    fetchTags();
  }, []);

  const fetchTags = async () => {
    console.log('开始获取标签');
    setLoading(true);
    try {
      const response = await tagService.getTags();
      console.log('获取标签成功:', response);
      if (response && response.data && Array.isArray(response.data.items)) {
        console.log('使用response.data.items作为数据');
        setTags(response.data.items);
      } else if (response && Array.isArray(response.data)) {
        console.log('使用response.data作为数据');
        setTags(response.data);
      } else if (Array.isArray(response)) {
        console.log('直接使用response作为数据');
        setTags(response);
      } else {
        console.log('数据格式不正确，设置为空数组');
        setTags([]);
      }
    } catch (error) {
      console.error('获取标签失败:', error);
      message.error('获取标签失败');
      setTags([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    console.log('点击添加按钮');
    setEditingId(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    console.log('点击编辑按钮:', record);
    setEditingId(record.id);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    console.log('点击删除按钮:', id);
    try {
      await tagService.deleteTag(id);
      console.log('删除成功');
      message.success('删除成功');
      fetchTags();
    } catch (error) {
      console.error('删除失败:', error);
      message.error('删除失败');
    }
  };

  const handleModalOk = async () => {
    console.log('点击模态框确定按钮');
    try {
      const values = await form.validateFields();
      console.log('表单验证通过，提交数据:', values);
      if (editingId) {
        console.log('更新标签:', editingId, values);
        await tagService.updateTag(editingId, values);
        message.success('更新成功');
      } else {
        console.log('创建标签:', values);
        await tagService.createTag(values);
        message.success('创建成功');
      }
      setModalVisible(false);
      fetchTags();
    } catch (error) {
      console.error('操作失败:', error);
      message.error(editingId ? '更新失败' : '创建失败');
    }
  };

  const columns = [
    {
      title: '标签名称',
      dataIndex: 'tag_name',
      key: 'tag_name',
    },
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            编辑
          </Button>
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  console.log('当前状态:', { 
    tags, 
    loading, 
    modalVisible, 
    editingId 
  });

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleAdd}>
          添加标签
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={tags}
        rowKey="id"
        loading={loading}
      />
      <Modal
        title={editingId ? '编辑标签' : '添加标签'}
        open={modalVisible}
        onOk={handleModalOk}
        onCancel={() => setModalVisible(false)}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="tag_name"
            label="标签名称"
            rules={[{ required: true, message: '请输入标签名称' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default QuestionTagManage; 